import eventDaysFormatter from "components/Global/Table3/CellFormatters/EventDays/utils";

export default function(value, eventDetails) {
  return eventDaysFormatter(value, eventDetails.date_groups)
    .map(({ label }) => label)
    .join(", ");
}
